import axios from '../utils/axios';

export default function getAllRecruitersCount (adminId, params) {
    return axios.get(`/admin/${adminId}/get-all-recruiters-count`, { params });
}